// extracted by mini-css-extract-plugin
export default {"root":"QuestionList_root__3zD3h","message":"QuestionList_message__sCRJs"};